GP.GPMod('ReadStatus',function(self){
    var vent   = null;
    var common = null;
    var _log   = null;

    var _conf = {
        // prices are in credits
        price: 50,
        success_modal_timeout:  4000
    };

    var _data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            common = self.app.Util;
            _log   = self.app.Util.log;

            _data.processing_read_status = false;
            _data.processed_read_status = false;

            if (typeof _msg_read_status_credit_price != 'undefined') {
                _conf.price = _msg_read_status_credit_price;
            }
        },
        page:  1,
        limit: 1,
        override_confirm: false,
        processing_read_status: false,
        processed_read_status: false,
    };

    var gui = {
        init: function() {
            this.$body                   = $('body');
            this.$btn_purchase_read_status = $('.btn-purchase-read-status');
            this.$btn_purchase_credits   = $('.btn-credits-read-status');
        }
    };

    var apis = {
        add_read_status: function() {
            var _other_duid = gui.$btn_purchase_read_status.data('other_duid');
            var _thread_id = gui.$btn_purchase_read_status.data('thread_id');

            if (!_data.processing_read_status && !_data.processed_read_status) {
                _data.processing_read_status = true;

                $.post('/members/msg/read_status_modal', {
                    'process' : 1,
                    'other_duid' : _other_duid
                })
                .done(function(json) {
                    if (json && json.success) {
                        _data.processed_read_status = true;
                        handlers.read_status_success();

                        GP.vent.trigger('MessagePane.Thread:reset_thread', _thread_id);
                        vent.trigger('Modal:close', _conf.success_modal_timeout);
                    } else {
                        handlers.read_status_error(json);
                    }
                })
                .fail(function() {
                    handlers.read_status_error();
                })
                .always(function() {
                    _data.processing_read_status = false;
                });
            }
        }
    };

    var handlers = {
        read_status_success: function() {
            var $success_container = $('.modal .alert-success');
            $success_container.removeClass('hide');
            setTimeout(function() {
                $success_container.addClass('hide');
            }, 3000);

            // hide link in thread view
            // $('.sent-msg-read-status').hide();
        },
        read_status_error: function(json) {
            var error_message = 'Read status purchase error occured';

            if (json && json.error) {
                error_message = json.error;
            }

            var $error_container = $('.modal .alert-danger');
            $error_container.find('p').remove();

            $error_container.append('<p class="error">'+error_message+'</p>');
            $error_container.removeClass('hide');
        }
    };

    var events = {
        init: function() {
            vent.on(self.moduleName+":setup_modal",events.setup_modal);
        },
        setup_modal: function() {
            gui.init();
            _data.init();

            // purchase read status
            $('.btn-purchase-read-status').on('click', function() {
                $(this).addClass('disabled');
                apis.add_read_status();
            });
            // show the purchase credits modal if we don't have enough credits
            $('.btn-credits-read-status').on('click', function() {
                events.show_purchase_credits();
            });

            events.show_submit_btn();
        },
        show_purchase_credits: function() {
            var _self = this;

            // bind to custom event that the iframe success template will trigger
            $('body').one('fl_credits_purchased', function(e) {
                _oc = false;

                // if this is called, we don't need to use the fl_modal_closed event
                $(document).off('fl_modal_closed');

                // give the PB some time to update the DB and fire the mod_user_credits cometd message
                // which should update the user's shared data (sdata)
                setTimeout(function() {
                    $('#msg-read-status-form').show();
                    $('iframe.msg-read-status-frame').addClass('hide');
                    events.show_purchase_btn();

                    // if we have credits now, call the add_read_status() api
                    if (GP.sdata.my_user.credits > 0) {
                        apis.add_read_status();
                    } else {
                        // check/refresh credits via ajax call, and call add_read_status if we have enough credits
                        events.refresh_credits(_self);
                    }
                }, 2000);
            });

            $('#msg-read-status-form').hide();
            $('iframe.msg-read-status-frame').removeClass('hide');
        },
        show_submit_btn: function() {
            if (GP.sdata.my_user.credits >= _conf.price) {
                events.show_purchase_btn();
            } else {
                events.show_purchase_credits_btn();
            }
        },
        show_purchase_btn: function() {
            gui.$btn_purchase_read_status.removeClass('hide');
            gui.$btn_purchase_credits.addClass('hide');
        },
        show_purchase_credits_btn: function() {
            gui.$btn_purchase_read_status.addClass('hide');
            gui.$btn_purchase_credits.removeClass('hide');
        },
        hide_submit_btns: function() {
            gui.$btn_purchase_read_status.addClass('hide');
            gui.$btn_purchase_credits.addClass('hide');
        },
        refresh_credits: function(_self) {
            vent.trigger('User:check_credits', _self, function(json) {
                var new_credits = parseInt(json.credits, 10);

                if (new_credits >= _conf.price) {
                    // pass apis.add_read_status as a callback so it fires after updating credits
                    vent.trigger('User:mod_user_credits', json,  apis.add_read_status, _self);
                }
            });
        }
    };

    this.addInitializer(function(){
        _data.init();
        events.init();
        gui.init();
    });
});
